<template>
    <section class="section">
        <h3 class="title is-3" :title="titleOfTitle">ЦПО: {{title}}</h3>

        <div class="columns mb-0">
            <div class="column is-4">
                <a @click="$router.back()" v-if="currentUser.isAdmin"><b-icon icon="backburger" size="is-small" /> Назад</a>
            </div>
            <div class="column is-offset-4 is-4">
                <b-datepicker
                    placeholder="Click to select..."
                    v-model="dates"
                    range>
                </b-datepicker>
            </div>
        </div>

        <hr />

        <b-table
            :data="tableData"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort-direction="asc"
            sort-icon="chevron-up"
            sort-icon-size="is-small"
            @click="clickRow"
            paginated
            striped
            narrowed
            hoverable
            focusable
            :selected.sync="selected"

            :backend-filtering="true"
            :backend-sorting="true"
            :backend-pagination="true"
            @filters-change="filterChange"
            @sort="sortChange"
            :total="page.total"

            :per-page="page.perPage"
            :current-page.sync="page.currentPage"

            :default-sort="page.sortBy"
            :default-sort-direction="page.sortDirection"

            default-sort="title"
            aria-next-label="Следующая страница"
            aria-previous-label="Предыдущая страница"
            aria-page-label="Страница"
            aria-current-label="Текущая страница"
        >

            <b-table-column cell-class="is-clickable" field="user.lastName" label="Фамилия"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.user.lastName }}
                </template>
            </b-table-column>
            <b-table-column cell-class="is-clickable" field="user.firstName" label="Имя"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.user.firstName }}
                </template>
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="user.surName" label="Отчество"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.user.surName }}
                </template>
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="total" label="Всего"  sortable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.total }}
                </template>
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="minimum" label="Мин"  sortable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.minimum }}
                </template>
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="average" label="Средний"  sortable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.average }}
                </template>
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="maximum" label="Макс"  sortable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.maximum }}
                </template>
            </b-table-column>
        </b-table>
    </section>

</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import { uniq, map, sortBy, get, find, debounce, cloneDeep, upperFirst } from 'lodash'
import { DateTime } from "luxon"
let toDay = DateTime.now()

export default {
    props: {
        organizationId: {
            required: true,
            type: String,
        }
    },
    computed: {
        ...mapGetters({
            organizationQuery: 'e/organizations/query',
            currentUser: 'e/users/currentUser',
            isLoaderActive: 'e/pages/isLoaderActive',
        }),
        title() {
            return get(this.organization, 'name',  'ЦПО <>')
        },
        titleOfTitle() {
            return this.organization ? this.organization.parentPath() : get(this.organization, 'name',  'ЦПО <>')
        },
        organization() {
            return this.organizationQuery().find(this.organizationId)
        }
    },
    methods: {
        ...mapActions({
            fetchUsersStats: 'e/users/fetchUsersStats',
        }),
        filterChange: debounce(function (val) {
            this.filters = cloneDeep(val)
        }, 300),
        sortChange: debounce(function (field, direction) {
            this.page.sortBy = field
            this.page.sortDirection = direction
        }, 300),
        fetch() {
            let params = {
                CpoId: this.organizationId,
                CurrentPage: this.page.currentPage,
                PerPage: this.page.perPage,
                SortDirection: this.page.sortDirection,
                SortBy: '',
            }

            if (this.dates[0]) {
                params['StartDate'] = DateTime.fromISO(this.dates[0].toISOString()).toFormat('yyyy-LL-dd')
            }

            if (this.dates[1]) {
                params['EndDate'] = DateTime.fromISO(this.dates[1].toISOString()).plus({ day: 1 }).toFormat('yyyy-LL-dd')
            }

            for (let i in this.filters) {
                if (this.filters[i])
                switch (i) {
                    case 'user.firstName':
                        params['FirstName'] = this.filters[i]
                        break;
                    case 'user.surName':
                        params['SurName'] = this.filters[i]
                        break;
                    case 'user.lastName':
                        params['LastName'] = this.filters[i]
                        break;
                    case 'user.positionId':
                        params['PositionId'] = this.filters[i]
                        break;
                    case 'user.groupId':
                        params['GroupId'] = this.filters[i]
                        break;
                    case 'roleId':
                        params['RoleId'] = this.filters[i]
                        break;

                }
            }
            let sortBy = ''

            switch (this.page.sortBy) {
                case 'user.firstName':
                    sortBy = 'FirstName'
                    break;
                case 'user.surName':
                    sortBy = 'SurName'
                    break;
                default:
                case 'user.lastName':
                    sortBy = 'LastName'
                    break;
                case 'total':
                case 'minimum':
                case 'average':
                case 'maximum':
                    sortBy = upperFirst(this.page.sortBy)
                    break;
            }
            params['SortBy'] = sortBy

            this.fetchUsersStats(params).then((data)=>{
                this.page.total = get(data, 'meta.total')
                this.page.ids = map(get(data, 'data'), 'user.id')
                this.tableData = get(data, 'data')
            })
        },
        clickRow(row) {
            let routeData = this.$router.resolve({name: 'users.tests.index', params: {userId: row.user.id}});
            window.open(routeData.href, '_blank');


            //this.$router.push({name: 'users.tests.index', params: {id: row.user.id}})
        },
    },
    data() {
        return {
            dates: [toDay.startOf('month').toJSDate(), toDay.endOf('month').toJSDate()],
            page: {
                perPage: 20,
                sortDirection: 'desc',
                sortBy: 'LastName',
                currentPage: 1,
                ids: [],
                total: 0,
            },
            filters: {},
            selected: {},
            tableData: []
        }
    },
    watch: {
        dates() {
            this.fetch()
        },
        'page.currentPage'() {
            this.fetch()
        },
        filters: {
            deep: true,
            handler() {
                this.fetch()
            }
        },
        'page.sortBy'() {
            this.fetch()
        },
        'page.sortDirection'() {
            this.fetch()
        },
        organizationId: {
            immediate: true,
            handler (organizationId) {
                if (organizationId) {
                    this.fetch()
                }
            }
        },
    }
}
</script>